// Permission-denied errors are opaque ("missing or insufficient permissions")
// and hide the real problem: WHO the request ran as. A staff session silently
// demoted to anonymous (see CLAUDE.md gotcha 2026-06-09) looks identical to a
// rules bug until you know the identity. Surface it at the point of failure.
import { auth } from "../firebase";

export function describeSaveError(err) {
  if (err?.code !== "permission-denied") return err?.message || String(err);
  const u = auth.currentUser;
  const who = u ? (u.isAnonymous ? "anonymous session" : u.email) : "signed out";
  return (
    `${err.message}\n\nThis request ran as: ${who}.` +
    `\nStaff writes require jump@thejoyofpancakes.com — log out and back in, ` +
    `then retry. If this keeps happening, hard-refresh this tab first.`
  );
}
